import { Component, effect, EventEmitter, forwardRef, Inject, Input, input, Optional, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { addMinutes } from 'date-fns';
import { MaterialModule } from 'src/app/material.module';
import { formatTime, getNearestFullTime, updateTime } from '../../helper/date-format.helper';
import { TimePickerComponent } from '../../time-picker/time-picker.component';
import {
  firstValueFrom,
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
  of,
  Observable,
  timer,
  timeout,
  Subscription,
} from 'rxjs';
import { tasksServices } from 'src/app/services/tasks.service';
import { leadsServices } from 'src/app/services/lead.service';
import { AutoCompleteComponent } from '../../auto-complete/auto-complete.component';
import { CalendarComponent } from '../calendar.component';
import { CommonModule } from '@angular/common';
import { campusServices } from 'src/app/services/campus.service';
import { SelectComponent } from '../../select/select.component';
import { HtmlEditorComponent } from '../../html-editor/html-editor.component';
import { userServices } from 'src/app/services/users.service';
import { googleCalendar } from 'src/app/services/google-calendar.service';
import { ZoomService } from 'src/app/services/zoom.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { ActivitySkeletonLoaderComponent } from '../../loading-models/loading-activity';
import { CampusCacheService } from 'src/app/services/cache/campus-cache';
import { UsersCacheService } from 'src/app/services/cache/users-cache';
import { activityTypeCache } from 'src/app/services/cache/activity-types-cache';
import { AttendeesManagerComponent } from '../../attendees-manager/attendees-manager.component';
import { CustomAttendeesManagerComponent } from '../../app-custom-attendees-manager/app-custom-attendees-manager.component';
import { AttendanceStatusModalComponent } from '../app-attendance-status-modal/app-attendance-status-modal.component';
import { StatusConfirmationDialogComponent } from '../app-status-confirmation-dialog/app-status-confirmation-dialog.component';
import { MatChipListbox } from '@angular/material/chips';
import { RescheduleModalComponent } from '../app-reschedule-modal/app-reschedule-modal.component';
import { ActivityCompletionService } from 'src/app/services/activity-completion.service';
import { companyService } from 'src/app/services/company.service';
import { DialogComponent } from '../../dialog/confirm.dialog';
import { noteService } from 'src/app/services/note-service';
import { ActivityAction, ActivityModalDataService } from 'src/app/services/lead-activity-modal.service';
import { Router } from '@angular/router';
import { RecurrenceConfigComponent, RecurrenceConfig } from '../recurrence-config/recurrence-config.component';
import { RecurrenceScopeDialogComponent } from '../recurrence-scope-dialog/recurrence-scope-dialog.component';
import { mapUserForDisplay } from '@app/shared/helper/functionts';

@Component({
  selector: 'app-event-confirmation-dialog',
  standalone: true,
  templateUrl: './event-confirmation-dialog.component.html',
  styleUrl: './event-confirmation-dialog.component.scss',
  imports: [
    MaterialModule, ReactiveFormsModule, TimePickerComponent, AutoCompleteComponent, CommonModule, SelectComponent, HtmlEditorComponent,
    ActivitySkeletonLoaderComponent, AttendeesManagerComponent, CustomAttendeesManagerComponent, StatusConfirmationDialogComponent, RescheduleModalComponent,CalendarComponent,
    RecurrenceConfigComponent
  ]
})
export class EventConfirmationDialogComponent {
  inputData = input<any>()

  eventForm: FormGroup;
  timeOptions: string[] = [];
  activityTypes: any[] = [];
  appointmentCategories: any[] = []; // Categories for appointments
  subcategories: any[] = []; // For storing subcategories of selected activity type
  showSubcategories: boolean = false; // Flag to show subcategories
  showSubcategoryDropdown: boolean = false; // Flag to show dropdown vs text
  leadOptions: {id: string, name: string}[] =[];
  attendeeOptions: {id: string, name: string}[] =[];
  activity: any;
  isTitleFocused: boolean = false;
  editMode: boolean = false;
  detailed : boolean = false;
  isSaving: boolean = false;
  private initialFormSnapshot: string | null = null;
  detailedInfo: any;
  dataInfo: any;
  calendarReady = false;
  isExternal : boolean = false;
  isModal : boolean = false;
  allDay: boolean = true;
  campuses: any[] = [];
  enableDetailNavigation: boolean = true;
  companyActiveFollowUpCheck: boolean = false;
  quillModule = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'], // Basic formatting
        ['link'], // Media options
        [{ list: 'ordered' }, { list: 'bullet' }], // Lists
        ['clean'], // Clear formatting
        ['speechToText'], // Add speech-to-text button
      ],
      handlers: {
        speechToText: () => {}, // Placeholder for now, managed in HtmlEditorComponent
      },
    },
  };
  focusTime : any;
  endDateFocusTime: any;
  userId: any;
  users: any[] = [];
  leads : any[] = [];
  showButton : boolean = false;
  showMeeting: boolean = false;
  tooltipMessage: string = 'Copy to clipboard';
  isLoading: boolean =  false;
  contacts: any[] = [];
  showDefaultAttendees: boolean = true;
  hasGoogleMeet : boolean = false;
  hasZoom : boolean = false;
  selectedProvider: 'google' | 'zoom' | null = null;
  zoomMeetingData: any = null;
  zoomMeetingStartTime: Date | null = null;
  zoomMeetingEndTime: Date | null = null;
  isPageLoading: boolean = false;
  isReschedule: boolean = false; // New property for reschedule flow
  attendanceStatuses: {value: string, label: string, color: string}[] = [
    { value: 'SCHEDULED', label: 'Scheduled', color: 'primary' },
    { value: 'SHOW', label: 'Show', color: 'accent' },
    { value: 'NO_SHOW', label: 'No-Show', color: 'warn' },
    { value: 'CANCEL', label: 'Cancel', color: 'warn' },
    { value: 'RESCHEDULED', label: 'Rescheduled', color: 'basic' }
    
  ];
  private currentDuration: number = 30;
  currentAttendanceStatus: string = 'SCHEDULED';  // <-- Is this added?
  hasSettingsAccess: boolean = false;
  private _pendingChipStatus: string | null = null;


  @ViewChild('statusChips') statusChips: MatChipListbox;

  showOutcomeSelection: boolean = false;
  activityOutcomes: any[] = [];
  selectedOutcome: number | null = null;
  isVirtual: boolean = false;
  isGeneral: boolean = false;
  isRecurring: boolean = false;
  lastAcceptedTypeId: any = null;
  appointmentMode: 'campus' | 'virtual' = 'campus';
  
  userNoteUsage: any[] = [];
  loadingSuggestions: boolean = false;
  showQuickNotes: boolean = false;
  quickNotesLoaded: boolean = false;
  showDefaultTime: boolean = true;
  @Input() isEmbedded: boolean = false;
  @Output() activitySaved = new EventEmitter<any>();
  @Output() activityClosed = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();

  private subscriptions = new Subscription();
  @Input() hideRightPaneCalendar: boolean = false;
  rightPaneCollapsed: boolean = false;
  isCalendarVisible: boolean = false;

  

  constructor(
    private fb: FormBuilder,
    private taskService: tasksServices,
    private leadsService: leadsServices,
    private campusCacheService: CampusCacheService,
    private userCacheService: UsersCacheService,
    private activityTypeCache: activityTypeCache,
    private googleCalendar: googleCalendar,
    private zoomService: ZoomService,
    private clipboard: Clipboard,
    private activityCompletionService: ActivityCompletionService,
    private companyService: companyService,
    private dialog: MatDialog, // Add MatDialog for proper modals
    private noteService: noteService,
    private modalDataService: ActivityModalDataService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: any,
    @Optional() private dialogRef?: MatDialogRef<EventConfirmationDialogComponent>,
  ) {
    // Initialize basic user data
    const user = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null;

    this.userId = user ? user.id : null;
    this.companyActiveFollowUpCheck = user?.Company?.active_follow_up_check || false;
    this.hasSettingsAccess = user?.role === 'ADMIN';


    if(user){
      this.hasGoogleMeet = user.GoogleTokens?.find(row => row.service === "MEET") ? true : false;
      this.hasZoom = user.GoogleTokens?.find(row => row.service === "ZOOM") ? true : false;
    }

    if(user?.Company?.activity_default_all_day){
      this.showDefaultTime = false;
    }
    // this.isEmbedded = !this.dialogRef && !this.inputData().leadView;
  
  // FIXED: Set data source based on context
  if (this.isEmbedded) {
    // When embedded, prioritize inputData signal
    this.dataInfo = this.modalDataService.getCurrentActivityData();
  } else {
    // When in dialog, use MAT_DIALOG_DATA
    this.dataInfo = data?.activityData || data;
  }

    // Initialize basic form structure
    this.eventForm = this.fb.group({
      name: [''],
      type: [''],
      appointmentCategory: [''],
      subcategory: [''],
      startDate: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: [''],
      lead: [ ''],
      campus: [null],
      assignedTo: null,
      dueDate: [''],
      meetingLink: [''],
      meetingName: [''],
      meetingCode: [''],
      meetingProvider: ['google'],
      zoomMeetingId: [''],
      zoomJoinUrl: [''],
      zoomStartUrl: [''],
      zoomPassword: [''],
      attendees: [[]],
      meetingOwner: [''],
      completed: [],
      status: ['SCHEDULED'],
      recurrence: new FormControl(null),
    });

      
    // Setup effect for input data changes
    effect(() => {
      const inputData = this.inputData();
      if (inputData && !this.isPageLoading) {
        this.reinitializeWithNewData(inputData);
      }
    });
  }

  async ngOnInit() {
    try {
      this.isPageLoading = true;
      if (this.isEmbedded) {
        
        this.subscriptions.add(
          this.modalDataService.activityData$.subscribe(activityData => {
            if (!activityData) { return; }
        
            // 🔀 merge the existing dataInfo with the new payload
            // (shallow merge – top-level keys only, preserve UI-only flags)
            this.dataInfo = {
              ...this.dataInfo,
              ...activityData,
              editMode: activityData.editMode !== undefined ? activityData.editMode : this.editMode,
            };
        
            // if you need to re-init only when the page is ready:
            if (!this.isPageLoading) {
              this.reinitializeWithNewData(this.dataInfo);
            }
          })
        );
        
      }
      await this.initializeComponent();
    } catch (error) {
      console.error('Initialization failed:', error);
      this.handleInitializationError(error);
    } finally {
      this.isPageLoading = false;
      this.calendarReady = true;
    }

    if (this.hideRightPaneCalendar) {
      this.rightPaneCollapsed = true;
    }
  }

  // Mobile calendar methods (ADD THESE)
showCalendar(): void {
  this.isCalendarVisible = true;
}

hideCalendar(): void {
  this.isCalendarVisible = false;
}

toggleCalendar(): void {
  this.isCalendarVisible = !this.isCalendarVisible;
}





  /**
   * Main initialization method - orchestrates the entire setup process
   */
  private async initializeComponent(): Promise<void> {
    // 1. Load all required data in parallel
    await this.loadRequiredData();
    
    // 2. Initialize form with proper data
    await this.initializeFormData();
    
    // 3. Check provider authentication status
    await this.checkProviderAuthentication();
    
    // 3.5. Initialize selected provider
    if (this.editMode) {
      // In edit mode, use the activity's meeting provider
      const meetingProvider = this.eventForm.get('meetingProvider')?.value;
      this.selectedProvider = (meetingProvider === 'zoom' || meetingProvider === 'google') ? meetingProvider : null;
    } else {
      // In create mode, use last selected provider
      this.selectedProvider = this.getLastSelectedProvider();
    }
    
    // 4. Setup form subscriptions and listeners
    this.setupFormSubscriptions();

    // 5. Initialize outcomes if needed
    await this.initializeOutcomes();

    this.captureInitialFormSnapshot();
  }

  private captureInitialFormSnapshot(): void {
    try {
      this.initialFormSnapshot = this.serializeFormForComparison(this.eventForm?.value);
    } catch {
      this.initialFormSnapshot = null;
    }
  }

  // Normalizes startDate/endDate/dueDate to YYYY-MM-DD so datepicker-driven
  // time drift doesn't register as a user change. startTime/endTime carry
  // the time portion separately.
  private serializeFormForComparison(value: any): string {
    if (!value) return JSON.stringify(null);
    const DATE_ONLY_KEYS = ['startDate', 'endDate', 'dueDate'];
    const normalized: any = { ...value };
    for (const key of DATE_ONLY_KEYS) {
      if (normalized[key]) {
        normalized[key] = this.toDateOnly(normalized[key]);
      }
    }
    return JSON.stringify(normalized);
  }

  private toDateOnly(value: any): string | null {
    try {
      const d = value instanceof Date ? value : new Date(value);
      if (isNaN(d.getTime())) return null;
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    } catch {
      return null;
    }
  }


  /**
   * Load all required data in parallel where possible
   */
  private async loadRequiredData(): Promise<void> {
    const dataSource = this.getInitializationData();
    
    // Load data in parallel
    const loadPromises: Promise<void>[] = [
      this.loadCampuses()
    ];
    
    // Load activity types if not provided
    if (!dataSource.activityTypes?.length) {
      loadPromises.push(this.loadActivityTypes());
    } else {
      this.activityTypes = dataSource.activityTypes;
      this.extractAppointmentCategories();
    }
    
    // Load users if not provided
    if (!dataSource.users?.length) {
      loadPromises.push(this.loadUsers());
    } else {
      this.users = dataSource.users.map(mapUserForDisplay);
    }
    
    await Promise.all(loadPromises);
  }

  /**
   * Load activity types from cache
   */
  private async loadActivityTypes(): Promise<void> {
    this.activityTypeCache.fetchData();
    const activityTypeCache = await firstValueFrom(this.activityTypeCache.data$);
    this.activityTypes = activityTypeCache;
    this.extractAppointmentCategories();
  }

  /**
   * Determine the data source for initialization
   */
  private getInitializationData(): any {
    // Set reschedule flag early
    const data = this.dataInfo || this.inputData()  || {};
    this.isReschedule = data?.isReschedule || false;
    this.isModal = !(this.inputData() && this.inputData().leadView);
    // Use dataInfo as primary source, fallback to inputData
    // if(this.isEmbedded){
    //   this.dataInfo = this.inputData();
    //   return this.inputData()
    // }

    if (this.dataInfo && !this.inputData()?.leadView) {
      return this.dataInfo;
    } else if (this.inputData()) {
      this.dataInfo = this.inputData();
      return this.dataInfo;
    }
    
    return {};
  }

  // private getInitializationData(): any {
  //   let data : any = {};
    
  //   // Determine data source based on context
  //   if (this.isEmbedded) {
  //     // When embedded, prioritize inputData signal over any dialog data
  //     const inputData = this.inputData();
  //     if (inputData) {
  //       data = inputData;
  //       this.dataInfo = {...inputData, disableCalendar: false, detailed: true}; // Update dataInfo with input data
  //     }
  //   } else {
  //     // When in dialog mode, use dataInfo (MAT_DIALOG_DATA)
  //     if (this.dataInfo) {
  //       data = this.dataInfo;
  //     } else if (this.inputData()) {
  //       // Fallback to inputData if no dialog data
  //       data = this.inputData();
  //       this.dataInfo = data;
  //     }
  //   }
    

    
  //   // Set flags based on the determined data
  //   this.isReschedule = data?.isReschedule || false;
    
  //   // Set modal flag based on context and data
  //   if (this.isEmbedded) {
  //     // When embedded, check if it's in leadView mode
  //     this.isModal = false;
  //   } else {
  //     // When in dialog, it's always modal
  //     this.isModal = true;
  //   }
    
  //   return data || {};
  // }

  /**
   * Initialize form with proper data and defaults
   */
  private async initializeFormData(): Promise<void> {
    const dataSource = this.getInitializationData();
    
    
    // Determine activity and type
    const { defaultType, activity } = this.determineActivityType(dataSource);
    this.activity = activity;
    this.isGeneral = this.activity?.is_general || false;
    
    // Set component flags
    this.detailed = dataSource?.detailed || false;
    this.editMode = dataSource.editMode || false;
    this.showDefaultAttendees = !dataSource?.task_attendees?.length;
    if(dataSource?.hideNavigation){
      this.enableDetailNavigation = false;
    }
    
    // Setup lead options if provided
    if (dataSource.lead?.id) {
      this.leadOptions.push({
        id: dataSource.lead.id.toString(), 
        name: 
        dataSource?.lead?.fullName ||
        dataSource?.lead?.email ||
          ((dataSource?.lead?.prefix || '') + (dataSource?.lead?.phoneNumber || '')) ||
          'No name',
      });
    }
    
    // Calculate time values
    const timeValues = this.calculateTimeValues(dataSource);
    
    // Build form data
    const formData = this.buildFormData(dataSource, defaultType, timeValues);
    
    // Create form with validators
    this.createFormWithData(formData);

    const startTime = this.eventForm.get('startTime')?.value;
    const endTime = this.eventForm.get('endTime')?.value;
    const startDate = this.eventForm.get('startDate')?.value;

    if (startTime && endTime && startDate && !this.allDay) {
        const startDateTime = updateTime(startDate, startTime);
        const endDateTime = updateTime(startDate, endTime);
        const durationMs = endDateTime.getTime() - startDateTime.getTime();
        this.currentDuration = Math.max(durationMs / (1000 * 60), 0) || this.dataInfo?.hourSegments || 30;
    } else {
        this.currentDuration = this.dataInfo?.hourSegments || 30;
    }
    
    // Set additional form states
    this.setAdditionalFormStates(dataSource);
  }

  /**
   * Determine the correct activity type and default
   */
  private determineActivityType(dataSource: any): { defaultType: string, activity: any } {
    let defaultType = '';
    let activity = null;
    
    if (dataSource.type?.id) {
      activity = this.activityTypes.find(row => row.id === dataSource.type.id);
      defaultType = activity?.id || '';
      
      // Handle appointment category for existing activity
      if (activity?.is_appointment && activity.appointment_category_id) {
        // This will be set in form data
      }
    } else if (dataSource.task) {
      activity = this.activityTypes.find(row => row.isTask) || this.activityTypes[0];
      defaultType = activity?.id || '';
    } else {
      activity = this.activityTypes[0];
      defaultType = activity?.id || '';
    }
    
    return { defaultType, activity };
  }

  /**
   * Calculate start/end times based on data source
   */
  private calculateTimeValues(dataSource: any): any {
    const sourceStart = dataSource?.start ? new Date(dataSource.start) : null;
    const sourceStartDate = dataSource?.startDate ? new Date(dataSource.startDate) : null;
    
    const startDate = sourceStartDate || sourceStart || new Date();
    const startTimeObj = sourceStartDate || sourceStart;
    let startTime = startTimeObj ? formatTime(startTimeObj) : null;
    const futureTime = new Date(addMinutes(getNearestFullTime(), dataSource.hourSegments || 30));
    this.focusTime = formatTime(futureTime);
    this.endDateFocusTime = formatTime(new Date(addMinutes(futureTime, dataSource.hourSegments || 30)));
    
    let endTime;
    
    if (dataSource.endDate) {
        endTime = formatTime(new Date(dataSource.endDate));
    } else if (dataSource.end) {
        endTime = formatTime(new Date(dataSource.end));
    } else if (startTimeObj) {
        const baseTime = new Date(startTimeObj);
        const calculatedEndTime = new Date(addMinutes(baseTime, dataSource.hourSegments || 30));
        
        // Cap at 11:59 PM if crossing midnight
        if (calculatedEndTime.getDate() !== baseTime.getDate()) {
            endTime = '11:59 PM';
        } else {
            endTime = formatTime(calculatedEndTime);
        }
    }
    
    if (dataSource.allDay) {
        this.allDay = dataSource.allDay;
        startTime = endTime = null;
    } else if (startTime) {
        this.allDay = false;
    }
    
    return { startDate, startTime, endTime };
}

  /**
   * Build form data object
   */
  private buildFormData(dataSource: any, defaultType: string, timeValues: any): any {
    
    const { startDate, startTime, endTime } = timeValues;
    
    // Process attendees
    const attendees = dataSource?.task_attendees?.map(row => ({
      id: row.user?.id, 
      name: row.user?.name ? `${row.user?.name} ${row.user?.lastName}(${row.user?.email})` : row.email
    }));
    
    // Determine attendance status (separate from task status)
    let status = 'SCHEDULED';
    if (this.editMode && dataSource.attendanceStatus) {
      status = dataSource.attendanceStatus;
    } else if (dataSource.appointment && dataSource.appointment?.status?.name) {
      status = dataSource.appointment.status?.name;
    } else if (dataSource?.status && ['SCHEDULED', 'SHOW', 'NO_SHOW', 'RESCHEDULED', 'CANCEL'].includes(dataSource.status)) {
      status = dataSource.status;
    }
  
    let assignedToValue = null;
    if (dataSource.assignedTo?.id) {
      assignedToValue = dataSource.assignedTo.id.toString();
    } else if (this.editMode && dataSource.userId) {
      assignedToValue = dataSource.userId.toString();
    } else if (!this.editMode) {
      assignedToValue = this.userId.toString();
    }
  
    const formData = {
      name: [this.editMode && dataSource.title || ''],
      type: [defaultType],
      appointmentCategory: [this.activity?.appointment_category_id || ''],
      subcategory: [dataSource?.subcategory || ''],
      startDate: [startDate],
      startTime: [startTime],
      endTime: [endTime],
      lead: [dataSource?.lead?.id.toString() || dataSource?.defaultLead?.toString() || ''],
      campus: [null],
      notes: [dataSource.notes],
      assignedTo: [assignedToValue],
      dueDate: dataSource.dueDate,
      meetingLink: [dataSource?.meetingLink || ''],
      meetingOwner: [dataSource?.meetingOwner || ''],
      meetingName: [dataSource?.meetingName || ''],
      meetingCode: [dataSource?.meetingCode || ''],
      meetingProvider: [dataSource?.meetingProvider || 'google'],
      zoomMeetingId: [dataSource?.zoomMeetingId || ''],
      zoomJoinUrl: [dataSource?.zoomJoinUrl || ''],
      zoomStartUrl: [dataSource?.zoomStartUrl || ''],
      zoomPassword: [dataSource?.zoomPassword || ''],
      attendees: [attendees],
      completed: [dataSource?.completed ? dataSource?.completed : false],
      status: [status],
      recurrence: new FormControl(null),
      isVirtual: [dataSource?.isVirtual || dataSource?.appointment?.isVirtual || !!dataSource?.meetingLink || !!dataSource?.zoomJoinUrl || this.activity?.is_virtual || false],
    };
    
    // Track attendance status separately
    this.currentAttendanceStatus = status;
    
    return formData;
  }

  /**
   * Create form with data and validators
   */
  private createFormWithData(formData: any): void {
    this.eventForm = this.fb.group(formData, { 
      validators: Validators.compose([this.timeRangeValidator, this.validateDateRange]) 
    });
  }

  /**
   * Set additional form states after creation
   */
  private setAdditionalFormStates(dataSource: any): void {
    // Set campus if available
    if (dataSource?.campus?.id) {
      this.eventForm.patchValue({
        campus: dataSource.campus.id.toString()
      });
    }
    
    // Set assigned user
    this.eventForm.patchValue({
      assignedTo: dataSource.assignedTo?.id?.toString() || this.userId.toString()
    });
    
    // Handle meeting states
    if (dataSource.meetingLink) {
      this.showMeeting = true;
      this.showButton = false;
    }

    // Auto-detect virtual from isVirtual flag OR meeting fields
    const detectedVirtual = 
    dataSource?.isVirtual || 
    dataSource?.appointment?.isVirtual ||
    !!dataSource?.meetingLink ||
    !!dataSource?.zoomJoinUrl ||
    this.activity?.is_virtual;  // ← inherit from type

    if (detectedVirtual) {
      this.isVirtual = true;
      this.appointmentMode = 'virtual';
      this.showMeeting = !!dataSource.meetingLink || !!dataSource.zoomJoinUrl;
      this.showButton = !dataSource.meetingLink && !dataSource.zoomJoinUrl;
    } else {
      this.isVirtual = false;
      this.appointmentMode = 'campus';
    }
    
    // Load subcategories if needed
    if (this.activity) {
      this.loadSubcategories(this.activity);
    }

    const leadControl = this.eventForm.get('lead');
    if (this.activity?.is_appointment) {
      leadControl?.addValidators(Validators.required);
      leadControl?.updateValueAndValidity();
    }

    // Populate recurrence data if editing a recurring event
    if (this.dataInfo?.recurrenceRule) {
      this.eventForm.get('recurrence')?.setValue({
        frequency: this.dataInfo.recurrenceRule.frequency,
        interval: this.dataInfo.recurrenceRule.interval,
        daysOfWeek: this.dataInfo.recurrenceRule.days_of_week,
        dayOfMonth: this.dataInfo.recurrenceRule.day_of_month,
        endType: this.dataInfo.recurrenceRule.end_type,
        endCount: this.dataInfo.recurrenceRule.end_count,
        endDate: this.dataInfo.recurrenceRule.end_date,
      });
    }

    // Mark as recurring if the task belongs to a recurrence series
    this.isRecurring = !!this.dataInfo?.recurrence_rule_id || !!this.eventForm.get('recurrence')?.value;
  }

  /**
   * Setup form subscriptions and listeners
   */
  private setupFormSubscriptions(): void {
    // Appointment category changes
    this.eventForm.get('appointmentCategory')?.valueChanges.subscribe(categoryId => {
      if (categoryId) {
        const activity = this.activityTypes.find(a => a.id == this.eventForm.get('type')?.value);
        if (activity) {
          this.loadSubcategories(activity);
        }
      }
    });
    
    // Seed with the form's current value so the first revert has something to fall back to
    this.lastAcceptedTypeId = this.eventForm.get('type')?.value ?? null;

    // Type changes — note: getActivity() runs from the template's (change) handler,
    // so we only clear appointment fields here when switching to a non-appointment type
    // and avoid calling getActivity() again (which would double-open the lead-required dialog).
    this.eventForm.get('type')?.valueChanges.subscribe(typeId => {
      if (typeId) {
        const selectedType = this.activityTypes.find(type => type.id === typeId);
        if (selectedType && !selectedType.is_appointment) {
          this.eventForm.patchValue({
            appointmentCategory: '',
            subcategory: ''
          });
          this.showSubcategories = false;
        }
      }
    });

    this.eventForm.get('startTime')?.valueChanges.subscribe(startTime => {
      if (startTime && !this.allDay) {
        const startDate = this.eventForm.get('startDate')?.value;
        const endTime = this.eventForm.get('endTime')?.value;

        // Check if startDate is valid before proceeding
        if (!startDate) {
          return;
        }

        // Calculate and set new end time based on current duration
        const newStartDateTime = updateTime(startDate, startTime);
        const newEndTime = formatTime(new Date(addMinutes(newStartDateTime, this.currentDuration)));

        // Update end time without triggering its valueChanges
        this.eventForm.get('endTime')?.setValue(newEndTime, { emitEvent: false });
      }
    });

    // Track duration when end time changes
    this.eventForm.get('endTime')?.valueChanges.subscribe(endTime => {
      if (endTime && !this.allDay) {
        const startTime = this.eventForm.get('startTime')?.value;
        const startDate = this.eventForm.get('startDate')?.value;

        // Check if both startDate and startTime are valid before proceeding
        if (startTime && startDate) {
          // Calculate duration between start and end times
          const startDateTime = updateTime(startDate, startTime);
          const endDateTime = updateTime(startDate, endTime);

          // Calculate duration in minutes
          const durationMs = endDateTime.getTime() - startDateTime.getTime();
          this.currentDuration = Math.max(durationMs / (1000 * 60), 0) || this.dataInfo?.hourSegments || 30;
        }
      }
    });

    
  
    
    // Detailed view changes
    if (this.detailed && this.dataInfo) {
      this.eventForm.valueChanges.subscribe((formValues) => {
        this.handleDetailedViewChanges(formValues);
      });
    }

    // Recurrence excludes the lead: when a recurrence is set, clear the lead
    // field, strip its Required validator, and disable the control. When the
    // recurrence is cleared, re-enable it (Required is re-applied later if the
    // activity type is an appointment).
    this.eventForm.get('recurrence')?.valueChanges.subscribe((recurrence) => {
      this.applyRecurrenceLeadLock(!!recurrence || !!this.dataInfo?.recurrence_rule_id);
    });
    this.applyRecurrenceLeadLock(!!this.eventForm.get('recurrence')?.value || !!this.dataInfo?.recurrence_rule_id);
  }

  private applyRecurrenceLeadLock(isRecurring: boolean): void {
    this.isRecurring = isRecurring;
    const leadControl = this.eventForm.get('lead');
    const typeControl = this.eventForm.get('type');
    if (!leadControl) return;
    if (isRecurring) {
      leadControl.removeValidators(Validators.required);
      leadControl.setValue(null, { emitEvent: false });
      leadControl.disable({ emitEvent: false });
      // Only lock the activity type when editing an existing recurring task
      if (this.editMode) {
        typeControl?.disable({ emitEvent: false });
      }
    } else {
      if (leadControl.disabled) {
        leadControl.enable({ emitEvent: false });
        if (this.activity?.is_appointment) {
          leadControl.addValidators(Validators.required);
        }
      }
      typeControl?.enable({ emitEvent: false });
    }
    leadControl.updateValueAndValidity({ emitEvent: false });
  }

  private async updateCampusForLead(leadId: any): Promise<void> {
    const lead = this.leads.find(row => row.id === leadId);
    if (!lead || !lead.campus?.id) {
      this.eventForm.patchValue({
        campus: null
      }, { emitEvent: false });
    } else {
      this.eventForm.patchValue({
        campus: lead.campus.id.toString()
      }, { emitEvent: false });
    }
  }

  

  private async handleLeadSelection(lead: any): Promise<void> {
    try {
      const leadData = await firstValueFrom(this.leadsService.getOne(lead?.id));
      
      if (leadData) {
        // Update the modal data service with the selected lead
        this.modalDataService.setLeadData(leadData);
        
        // Optional: Update campus if lead has one
        if (leadData.campus?.id && !this.eventForm.get('campus')?.value) {
          this.eventForm.patchValue({
            campus: leadData.campus.id.toString()
          }, { emitEvent: false }); // Don't emit to avoid circular updates
        }
      }
    } catch (error) {
      console.error('Error fetching lead data:', error);
      // Don't break the flow, just log the error
    }
  }

  /**
   * Handle detailed view form changes
   */
  private handleDetailedViewChanges(formValues: any): void {
    if (formValues.startTime && this.allDay) {
      this.allDay = false;
    }
    
    // if (formValues.startTime && !formValues.endTime) {
    //   const time = updateTime(formValues.startDate, formValues.startTime);
    //   this.eventForm.patchValue({ 
    //     endTime: formatTime(new Date(addMinutes(time, this.dataInfo.hourSegments || 30))) 
    //   });
    // }
    
    const activitytype = this.activityTypes.find(row => row.id == formValues.type);
    this.detailedInfo = {
      ...formValues, 
      editMode: this.editMode, 
      id: this.dataInfo.id || Date.now(), 
      title: formValues?.name || activitytype?.name || '', 
      type: this.activityTypes.find(row => row.id == formValues.type),
      appointment_category: this.appointmentCategories.find(cat => cat.id == formValues.appointmentCategory)
    };
  }

  /**
   * Initialize outcomes for appointments if needed
   */
  private async initializeOutcomes(): Promise<void> {
    const dataSource = this.getInitializationData();
    
    // If editing an appointment with SHOW status, load outcomes
    if (this.editMode && 
        dataSource.attendanceStatus === 'SHOW' && 
        this.activity?.is_appointment) {
      await this.loadActivityOutcomes();
      
      // Set the existing outcome if available
      if (dataSource.outcome_id && this.activityOutcomes.length > 0) {
        this.selectedOutcome = dataSource.outcome_id;
      }
    }
  }

  async loadUserNoteUsage() {
    // Don't load if already loaded or currently loading
    if (this.quickNotesLoaded || this.loadingSuggestions) {
      return;
    }
    
    this.loadingSuggestions = true;
    try {
      const response = await firstValueFrom(this.noteService.get({}, 'usage'));
      if (response) {
        this.userNoteUsage = response;
        this.quickNotesLoaded = true;
      }
    } catch (error) {
      console.error('Failed to load note suggestions:', error);
      this.userNoteUsage = [];
    } finally {
      this.loadingSuggestions = false;
    }
  }

  toggleQuickNotes() {
    this.showQuickNotes = !this.showQuickNotes;
    
    // Load data when expanding for the first time
    if (this.showQuickNotes && !this.quickNotesLoaded) {
      this.loadUserNoteUsage();
    }
  }

  insertSuggestion(suggestion: any) {
    const notesControl = this.eventForm.get('notes');
    if (notesControl) {
      const currentContent = notesControl.value || '';
      const newContent = currentContent ? currentContent + ' ' + suggestion.text : suggestion.text;
      notesControl.setValue(newContent);
    }
  }
  

  /**
   * Enhanced campus loading with proper error handling
   */
  private async loadCampuses(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.campusCacheService.fetchData();
      this.campusCacheService.data$.subscribe({
        next: (campuses) => {
          this.campuses = campuses;
          resolve();
        },
        error: (error) => {
          console.error('Error loading campuses:', error);
          reject(error);
        }
      });
    });
  }

  /**
   * Enhanced user loading with proper error handling
   */
  private async loadUsers(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userCacheService.fetchData();
      this.userCacheService.data$.subscribe({
        next: (users) => {
          this.users = users.map(mapUserForDisplay);

          resolve();
        },
        error: (error) => {
          console.error('Error loading users:', error);
          reject(error);
        }
      });
    });
  }

  /**
   * Handle initialization errors gracefully
   */
  private handleInitializationError(error: any): void {
    console.error('Component initialization failed:', error);
    
    // Set safe defaults to prevent component from breaking
    this.activityTypes = [];
    this.campuses = [];
    this.users = [];
    this.appointmentCategories = [];
    
    // Create a minimal form to prevent crashes
    this.eventForm = this.fb.group({
      name: [''],
      type: [''],
      appointmentCategory: [''],
      subcategory: [''],
      startDate: [new Date()],
      startTime: [''],
      endTime: [''],
      lead: [''],
      campus: [null],
      notes: [''],
      assignedTo: [this.userId?.toString() || ''],
      dueDate: [''],
      meetingLink: [''],
      meetingOwner: [''],
      meetingName: [''],
      meetingCode: [''],
      meetingProvider: ['google'],
      zoomMeetingId: [''],
      zoomJoinUrl: [''],
      zoomStartUrl: [''],
      zoomPassword: [''],
      attendees: [[]],
      completed: [false],
      status: ['SCHEDULED']
    });
  }

  /**
   * Reinitialize component with new input data
   */
  private async reinitializeWithNewData(newData: any): Promise<void> {
    try {
      this.isPageLoading = true;
      this.dataInfo = newData;
      await this.initializeFormData();
      this.setupFormSubscriptions();
      await this.initializeOutcomes();
      this.captureInitialFormSnapshot();
    } catch (error) {
      console.error('Error reinitializing with new data:', error);
    } finally {
      this.isPageLoading = false;
    }
  }

  onFocus(): void {
    this.isTitleFocused = true;
  }

  onBlur(): void {
    this.isTitleFocused = false;
  }

  // Extract unique appointment categories from activity types
  extractAppointmentCategories() {
    // Initialize array to store categories
    const categoriesMap = new Map();
    
    // Loop through activity types and collect unique categories
    this.activityTypes.forEach(type => {
      if (type.is_appointment && type.appointment_category && type.appointment_category_id) {
        if (!categoriesMap.has(type.appointment_category_id)) {
          categoriesMap.set(type.appointment_category_id, {
            id: type.appointment_category_id,
            name: type.appointment_category.name,
            icon: type.appointment_category.icon || 'event',
            is_financial_aid: type.appointment_category.is_financial_aid,
            is_career: type.appointment_category.is_career,
            is_academic: type.appointment_category.is_academic
          });
        }
      }
    });
    
    // Convert map to array
    this.appointmentCategories = Array.from(categoriesMap.values());
  }

  // Load subcategories for the selected activity type
  loadSubcategories(activity: any) {
    this.showSubcategories = false;
    this.subcategories = [];
    
    if (!activity || !activity.is_appointment || !activity.appointment_category_id) {
      return;
    }
    
    // Find the category for this activity
    const category = this.appointmentCategories.find(cat => cat.id === activity.appointment_category_id);
    
    // Check if this category has subcategories
    if (category && activity.appointment_category?.activity_subcategory?.length > 0) {
      this.subcategories = activity.appointment_category.activity_subcategory.filter(sub => sub.active);
      this.showSubcategories = this.subcategories.length > 0;
      
      // If there's only one subcategory, select it by default
      if (this.subcategories.length === 1) {
        this.eventForm.patchValue({
          subcategory: this.subcategories[0].id
        });
      }
    }
  }

  onStartTimeCleared(): void {
    // Clear end time when start time is cleared
    this.eventForm.patchValue({ endTime: '' });
    // Reset duration to default
    this.currentDuration = this.dataInfo?.hourSegments || 30;
}

  connectGoogleMeet() {
    const user = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null;
    if(!user)
      return
    this.googleCalendar.getAuthUrl(user.id, 'meet').subscribe((data:any) => {
      window.location.href = data.url; // Redirect to Google OAuth
    });
  }

  async createMeeting(){
    this.isLoading = true;
    const meeting : any = await firstValueFrom(this.googleCalendar.createMeeting(this.userId));
    this.eventForm.patchValue({
      meetingLink: meeting.meetingUri,
      meetingName: meeting.name,
      meetingCode: meeting.meetingCode,
      isVirtual: true // Add this line
    });
    this.isVirtual = true; // Add this line
    this.appointmentMode = 'virtual'; // Add this line
    this.showButton = false;
    this.showMeeting = true;
    this.isLoading = false;
    if(this.editMode){
      this.showDefaultAttendees = false;
    }
    this.eventForm.patchValue({ meetingOwner: this.userId });
  }

  removeMeeting(){
    this.eventForm.patchValue({
      meetingLink: '',
      meetingName: '',
      meetingCode: '',
      meetingProvider: 'google',
      zoomMeetingId: '',
      zoomJoinUrl: '',
      zoomStartUrl: '',
      zoomPassword: '',
      isVirtual: false // Add this line
    });
    this.isVirtual = false; // Add this line
    this.appointmentMode = 'campus'; // Add this line
    this.showButton = true;
    this.showMeeting = false;
    this.selectedProvider = 'google';
    this.zoomMeetingData = null;
  }

  // ==================== ZOOM METHODS ====================

  async onProviderChange(event: any): Promise<void> {
    this.selectedProvider = event.value;
    this.eventForm.patchValue({ meetingProvider: event.value });
    
    // Clear existing meeting data when switching providers
    this.eventForm.patchValue({
      meetingLink: '',
      meetingName: '',
      meetingCode: '',
      zoomMeetingId: '',
      zoomJoinUrl: '',
      zoomStartUrl: '',
      zoomPassword: '',
    });
    
    this.zoomMeetingData = null;
    
    // Check authentication status for the selected provider
    await this.checkProviderAuthentication();
  }

  async connectZoom(): Promise<void> {
    try {
      await this.zoomService.connectZoom(this.userId);
    } catch (error) {
      console.error('Error connecting to Zoom:', error);
      // Could show an error message here
    }
  }

  async createZoomMeeting(): Promise<void> {
    this.isLoading = true;
    
    try {
      const formValue = this.eventForm.value;
      
      const startDateTime = this.combineDateTime(formValue.startDate, formValue.startTime);
      const endDateTime = this.combineDateTime(formValue.startDate, formValue.endTime);
      
      const meetingData = this.zoomService.formatMeetingData({
        title: formValue.name || 'Meeting',
        startDate: startDateTime,
        endDate: endDateTime,
        notes: formValue.notes,
        attendees: formValue.attendees || [],
        userId: this.userId,
        password: this.zoomService.generateMeetingPassword(),
      });
      
      const meeting = await firstValueFrom(this.zoomService.createMeeting(meetingData));
      this.zoomMeetingData = meeting;

      // Store the actual times used for Zoom meeting creation
      this.zoomMeetingStartTime = startDateTime;
      this.zoomMeetingEndTime = endDateTime;

      // CRITICAL: Ensure form times match the Zoom meeting times
      // This prevents mismatch between Zoom meeting time and task save time
      if (startDateTime && endDateTime) {
        const startTime = this.formatTimeForForm(startDateTime);
        const endTime = this.formatTimeForForm(endDateTime);
        
        // Update form with the exact times used for Zoom meeting
        this.eventForm.patchValue({
          startTime: startTime,
          endTime: endTime,
          meetingLink: meeting.join_url,
          meetingProvider: 'zoom',
          zoomMeetingId: meeting.id.toString(),
          zoomJoinUrl: meeting.join_url,
          zoomStartUrl: meeting.start_url,
          zoomPassword: meeting.password,
          isVirtual: true
        });
      } else {
        this.eventForm.patchValue({
          meetingLink: meeting.join_url,
          meetingProvider: 'zoom',
          zoomMeetingId: meeting.id.toString(),
          zoomJoinUrl: meeting.join_url,
          zoomStartUrl: meeting.start_url,
          zoomPassword: meeting.password,
          isVirtual: true
        });
      }

      this.isVirtual = true;
      this.appointmentMode = 'virtual';
      this.showButton = false;
      this.showMeeting = true;

      if (this.editMode) {
        this.showDefaultAttendees = false;
      }

      this.eventForm.patchValue({ meetingOwner: this.userId });
    } catch (error) {
      console.error('Error creating Zoom meeting:', error);
      // Could show an error message here
    } finally {
      this.isLoading = false;
    }
  }

  selectProvider(provider: 'google' | 'zoom'): void {
    this.selectedProvider = provider;
    this.saveLastSelectedProvider(provider);
    
    // Execute the appropriate action based on provider and auth status
    if (provider === 'google') {
      if (this.hasGoogleMeet) {
        this.createMeeting();
      } else {
        this.connectGoogleMeet();
      }
    } else if (provider === 'zoom') {
      if (this.hasZoom) {
        this.createZoomMeeting();
      } else {
        this.connectZoom();
      }
    }
  }

  private saveLastSelectedProvider(provider: 'google' | 'zoom'): void {
    localStorage.setItem('lastSelectedMeetingProvider', provider);
  }

  private getLastSelectedProvider(): 'google' | 'zoom' | null {
    if (this.editMode) {
      // In edit mode, don't show any provider initially
      return null;
    }
    const savedProvider = localStorage.getItem('lastSelectedMeetingProvider');
    return (savedProvider === 'zoom' || savedProvider === 'google') ? savedProvider : null;
  }

  joinZoomMeeting(): void {
    const joinUrl = this.eventForm.get('zoomJoinUrl')?.value;
    if (joinUrl) {
      window.open(joinUrl, '_blank');
    }
  }

  copyZoomMeetingInfo(): void {
    const textToCopy = this.eventForm.get('zoomJoinUrl')?.value || null;
  
    if (!textToCopy) return;
  
    this.zoomService.copyToClipboard(textToCopy).then(success => {
      if (success) {
        this.tooltipMessage = 'Copied!';
        setTimeout(() => {
          this.tooltipMessage = 'Copy to clipboard';
        }, 2000);
      }
    });
  }

  private combineDateTime(date: Date, time: string): Date | undefined {
    if (!date || !time) return undefined;
    
    // Handle both 24-hour format (HH:mm) and 12-hour format (h:mm AM/PM)
    const timeRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i;
    const match = time.match(timeRegex);
    
    if (!match) {
      console.warn('Invalid time format:', time);
      return undefined;
    }
    
    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const period = match[3]?.toUpperCase();
    
    // Convert 12-hour to 24-hour format
    if (period) {
      if (period === 'PM' && hours !== 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }
    }
    
    const combined = new Date(date);
    combined.setHours(hours, minutes, 0, 0);
    
    return combined;
  }

  /**
   * Convert a Date object back to the form's time format (HH:mm)
   */
  private formatTimeForForm(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  /**
   * Check authentication status for meeting providers
   */
  private async checkProviderAuthentication(): Promise<void> {
    try {
      if (!this.userId) {
        console.warn('No userId available for provider authentication check');
        return;
      }

      // Check Zoom authentication
      const isZoomAuthenticated = await this.zoomService.isAuthenticated(this.userId);
      this.hasZoom = isZoomAuthenticated; // Update hasZoom property
      
      // Update UI based on authentication status and current form state
      if (this.selectedProvider === 'zoom') {
        const hasExistingZoomMeeting = !!this.eventForm.get('zoomJoinUrl')?.value;
        
        if (isZoomAuthenticated) {
          // User is authenticated
          if (hasExistingZoomMeeting) {
            // Already has a Zoom meeting, show meeting info
            this.showButton = false;
            this.showMeeting = true;
          } else {
            // Authenticated but no meeting yet, show create meeting button
            this.showButton = true; // Show button so user can create meeting
            this.showMeeting = false;
          }
        } else {
          // User is not authenticated, show connect button
          this.showButton = true;
          this.showMeeting = false;
        }
      } else if (this.selectedProvider === 'google') {
        // Handle Google authentication - you might want to add similar logic here
        const hasExistingGoogleMeeting = !!this.eventForm.get('meetingLink')?.value;
        if (hasExistingGoogleMeeting) {
          this.showButton = false;
          this.showMeeting = true;
        }
        // For Google, you might have similar authentication checking
      }
      
    } catch (error) {
      console.error('Error checking provider authentication:', error);
      // On error, default to showing connect button
      this.showButton = true;
      this.showMeeting = false;
    }
  }

  switchToVirtualMode(): void {
    this.appointmentMode = 'virtual';
    this.isVirtual = true;
    this.eventForm.patchValue({ isVirtual: true });
    this.showMeetForm()
    // Don't call showMeetForm() here, let the template handle the next step
  }
  
  switchToCampusMode(): void {
    this.appointmentMode = 'campus';
    this.isVirtual = false;
    this.eventForm.patchValue({ isVirtual: false });
    
    // Reset all meeting-related states
    this.showButton = false;  // Add this line
    this.showMeeting = false; // This was already there
    
    // Clear any meeting data when switching to campus
    if (this.eventForm.get('meetingLink')?.value) {
      this.eventForm.patchValue({
        meetingLink: '',
        meetingName: '',
        meetingCode: ''
      });
    }
  }

  addAttendees(){
    this.showDefaultAttendees = false;
  }

  copyMeetingLink(tooltip: any): void {
    const meetingLink = this.eventForm.get('meetingLink')?.value;
    if (meetingLink) {
      this.clipboard.copy(meetingLink);
      this.tooltipMessage = 'Copied!';
      tooltip.show();

      setTimeout(() => {
        this.tooltipMessage = 'Copy to clipboard';
        tooltip.hide();
      }, 2000);
    }
  }

  joinMeet(): void {
    const meetingLink = this.eventForm.get('meetingLink')?.value;
    if (meetingLink) {
      window.open(meetingLink, '_blank');
    }
  }

  showMeetForm(){
    this.showButton = true;
  }

  calendarData(event){
    const { start, end } = event;

    const startDate = start ? new Date(start) : null;
    const startTime = start ? formatTime(new Date(start)) : null;
    const endTime = end ? formatTime(new Date(end)) : formatTime(new Date(addMinutes(new Date(start), this.dataInfo.hourSegments || 30)));
    
    if(event.allDay){
      this.eventForm.patchValue({
        startDate: startDate,
        dueDate: startDate
      });
      return
    }
    
    this.eventForm.patchValue({
      startDate: startDate,
      startTime: startTime,
      endTime: endTime,
    });
  }

  

  async leadChange(event) {
    // Handle null/undefined/empty event when lead is cleared
    const leadId = event?.id;
    const lead = leadId ? this.leads.find(row => row.id === leadId) : null;
  
    if (this.isEmbedded) {
      if (lead) {
        await this.handleLeadSelection({ id: lead.id });
      } else {
        this.modalDataService.setLeadData(null);
      }
    }
  
    // Update campus based on lead selection (or clear if no lead)
    if (!lead || !lead.campus?.id) {
      this.eventForm.patchValue({
        campus: null
      });
    } else {
      this.eventForm.patchValue({
        campus: lead.campus.id.toString()
      });
    }
  
    // Explicitly set the lead field value when cleared
    if (!leadId) {
      this.eventForm.patchValue({
        lead: null
      }, { emitEvent: false });
    }
  }

  contactChange(event) {
    if (event.id && event.id.toString().startsWith('new-')) {
      this.showDefaultAttendees = false;
    } else {
      const contact = this.contacts.find(row => row.id === event.id);
      this.showDefaultAttendees = false;
      if (contact) {
        // Handle existing contact
      }
    }
  }

  get startTimeControl(): FormControl {
    return this.eventForm.get('startTime') as FormControl;
  }

  get endTimeControl(): FormControl {
    return this.eventForm.get('endTime') as FormControl;
  }

  getActivity(event){
    const candidate = this.activityTypes.find(row => row.id == event.value);

    if (candidate?.is_appointment && !this.eventForm.get('lead')?.value) {
      this.dialog.open(DialogComponent, {
        data: {
          header: 'Lead Required',
          content: 'Select a lead before choosing an appointment type.',
          isInfo: true,
        },
        width: '400px',
      });
      this.eventForm
        .get('type')
        ?.setValue(this.lastAcceptedTypeId ?? '', { emitEvent: false });
      return;
    }

    this.lastAcceptedTypeId = event.value;
    this.activity = candidate;
    this.isGeneral = this.activity?.is_general || false;

    // Require lead when type is appointment, remove requirement otherwise
    const leadControl = this.eventForm.get('lead');
    if (this.activity?.is_appointment) {
      leadControl?.addValidators(Validators.required);
    } else {
      leadControl?.removeValidators(Validators.required);
    }
    leadControl?.updateValueAndValidity();
  
    if (this.activity && this.activity.is_appointment && this.activity.appointment_category_id) {
      this.eventForm.patchValue({
        appointmentCategory: this.activity.appointment_category_id
      });
      this.loadSubcategories(this.activity);
    }
  
    if (this.activity?.is_virtual) {
      this.isVirtual = true;
      this.appointmentMode = 'virtual';
      this.eventForm.patchValue({ isVirtual: true });
    
      const hasExistingMeeting = !!this.eventForm.get('meetingLink')?.value || !!this.eventForm.get('zoomJoinUrl')?.value;
      this.showMeeting = hasExistingMeeting;
      this.showButton = !hasExistingMeeting;
    } else if (!this.eventForm.get('meetingLink')?.value && !this.eventForm.get('zoomJoinUrl')?.value) {
      this.isVirtual = false;
      this.appointmentMode = 'campus';
      this.eventForm.patchValue({ isVirtual: false });
      this.showButton = false;
      this.showMeeting = false;
    }
  }

  // Check if appointment is in the past
  isAppointmentInPast(): boolean {
    const startDate = this.eventForm.get('startDate')?.value;
    const startTime = this.eventForm.get('startTime')?.value;
    
    if (!startDate) return false;
    
    const now = new Date();
    
    if (this.allDay) {
      const appointmentDate = new Date(startDate);
      appointmentDate.setHours(0, 0, 0, 0);
      
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      
      return appointmentDate < todayDate;
    }
    
    if (!startTime) {
      return new Date(startDate) < now;
    }
    
    const timeMatch = startTime.match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (!timeMatch) return false;
    
    let hours = parseInt(timeMatch[1], 10);
    const minutes = parseInt(timeMatch[2], 10);
    const period = timeMatch[3].toUpperCase();
    
    if (period === 'PM' && hours < 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }
    
    const appointmentDateTime = new Date(startDate);
    appointmentDateTime.setHours(hours, minutes, 0, 0);
    
    return appointmentDateTime < now;
  }

  // Check if time fields should be read-only based on status
  isTimeReadOnly(): boolean {
    if (this.isReschedule) {
      return false;
    }
    
    const status = this.eventForm.get('status')?.value;
    const completed = this.eventForm.get('completed')?.value;
    
    return status === 'SHOW' || status === 'NO_SHOW' || status === 'RESCHEDULED' || status === 'CANCEL' || completed === true;
  }

  updateAttendanceStatus(status: string, skipStatusConfirmation: boolean = false): void {
    // If clicking on the already selected status, do nothing
    if (status === this.currentAttendanceStatus) {
      return;
    }
    
    const previousStatus = this.currentAttendanceStatus;
    
    if (status === 'SCHEDULED' || skipStatusConfirmation) {
      this.applyStatusChange(status);
      return;
    }
    
    const statusLabel = status === 'SHOW' ? 'Show' : status === 'NO_SHOW' ? 'No-Show' : 'Cancel';
    const dialogRef = this.dialog.open(StatusConfirmationDialogComponent, {
      width: '400px',
      data: {
        status: statusLabel
      }
    });
  
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.applyStatusChange(status);
      } else {
        this.currentAttendanceStatus = previousStatus;
        
        if (this.statusChips) {
          this.statusChips.value = previousStatus;
        }
      }
    });
  }

  private applyStatusChange(status: string): void {
    // Track attendance status separately
    this.currentAttendanceStatus = status;

    this.eventForm.patchValue({
      status: status,
      completed: status === 'SHOW' || status === 'NO_SHOW' || status === 'CANCEL'
    });

    if (status === 'SHOW' && this.activity?.is_appointment) {
      if (this.activityOutcomes.length === 0) {
        this.loadActivityOutcomes();
      } else {
        this.showOutcomeSelection = true;
      }
    } else {
      this.showOutcomeSelection = false;
      this.selectedOutcome = null;
    }

    if (this.dataInfo) {
      this.dataInfo.attendanceStatus = status;
      this.dataInfo.completed = status === 'SHOW' || status === 'NO_SHOW' || status === 'CANCEL';
    }
  }

  isOutcomeRequired(): boolean {
    return this.activity?.is_outcome_required || false;
  }

  private saveStatusUpdate(status: string, outcomeId?: number): void {
    if (!this.editMode || !this.dataInfo?.id) return;
    
    this.isLoading = true;
    
    const updateData: any = {
      attendanceStatus: status,
      completed: status === 'SHOW' || status === 'NO_SHOW' || status === 'CANCEL'
    };
    
    if (outcomeId) {
      updateData.outcome_id = outcomeId;
    }
    
    firstValueFrom(this.taskService.patch(updateData, this.dataInfo.id)).then(response => {
      this.dataInfo.status = status;
      this.dataInfo.attendanceStatus = status;
      this.dataInfo.completed = status === 'SHOW' || status === 'NO_SHOW' || status === 'CANCEL';
      if (outcomeId) {
        this.dataInfo.outcome_id = outcomeId;
      }
      
      this.showOutcomeSelection = false;
      this.isLoading = false;
    }).catch(error => {
      console.error('Error updating attendance status:', error);
      this.isLoading = false;
    });
  }

  onOutcomeSelected(outcomeId: number): void {
    this.selectedOutcome = outcomeId;
  }

  get showRightPane(): boolean {
    // Don't show right pane when hideRightPaneCalendar is true
    if (this.hideRightPaneCalendar) {
      return false;
    }
    // Default behavior - show if calendar should be available
    return this.detailed && !this.dataInfo?.task && !this.dataInfo?.disableCalendar;
  }
  
  get showToggleButton(): boolean {
    return this.hideRightPaneCalendar && 
           this.detailed && 
           !this.dataInfo?.task && 
           !this.dataInfo?.disableCalendar;
  }
  
  get leftPaneFullWidth(): boolean {
    // Only full width when hideRightPaneCalendar is true
    return this.hideRightPaneCalendar || !this.showRightPane;
  }

  get showCalendarToggle(): boolean {
    return this.hideRightPaneCalendar && 
           this.detailed && 
           !this.dataInfo?.task && 
           !this.dataInfo?.disableCalendar;
  }
  
  // 3. ADD this method:
  toggleRightPane(): void {
    // When hideRightPaneCalendar is true, show calendar overlay instead
    this.showCalendar();
  }

  // Method to reschedule an appointment
  rescheduleAppointment(): void {
    if (this.isFormTypeAppointment() && !this.resolveFormLeadId() && !this.isRecurring) {
      this.dialog.open(DialogComponent, {
        data: {
          header: 'Lead Required',
          content: 'An appointment must be linked to a lead. Please select a lead before saving.',
          isInfo: true,
        },
        width: '400px',
      });
      return;
    }

    const dialogRef = this.dialog.open(RescheduleModalComponent, {
      width: '600px',
      data: {
        currentAppointment: this.dataInfo
      }
    });
  
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          this.isLoading = true;
          
          const toIntId = (value: any): number | null => {
            if (value === null || value === undefined || value === '') return null;
            return typeof value === 'string' ? parseInt(value, 10) : value;
          };

          // Get company_id from dataInfo, fall back to localStorage user data
          let companyId = toIntId(this.dataInfo.company_id);
          if (!companyId) {
            const user = JSON.parse(localStorage.getItem('userData') || 'null');
            companyId = user?.company_id || null;
          }

          const reschedulePayload = {
            originalTaskId: toIntId(this.dataInfo.id),
            originalTask: {
              id: toIntId(this.dataInfo.id),
              company_id: companyId
            },
            newTask: {
              title: this.eventForm.value.name || this.activity?.name,
              notes: this.eventForm.value.notes,
              company_id: companyId,
              startDate: result.startDate,
              endDate: result.endDate,
              status: 'todo',
              completed: false,
              type: toIntId(this.eventForm.value.type),
              lead: toIntId(this.eventForm.value.lead),
              assignedTo: toIntId(this.eventForm.value.assignedTo),
              campus: toIntId(this.eventForm.value.campus),
              allDay: this.allDay,
              
              meetingLink: this.eventForm.value.meetingLink || '',
              meetingOwner: this.eventForm.value.meetingOwner || null,
              meetingName: this.eventForm.value.meetingName || '',
              meetingCode: this.eventForm.value.meetingCode || '',
              
              attendees: (this.eventForm.value.attendees || []).map(attendee => {
                if (typeof attendee.id === 'string' && attendee.id.startsWith('new-')) {
                  return {
                    id: attendee.id,
                    email: attendee.email || attendee.name
                  };
                } else {
                  const emailMatch = attendee.name?.match(/\(([^)]+)\)/);
                  let email = emailMatch ? emailMatch[1] : null;
                  
                  if (!email && attendee.name && this.isValidEmail(attendee.name)) {
                    email = attendee.name;
                  }
                  
                  return { 
                    id: toIntId(attendee.id),
                    email: email
                  };
                }
              }),
              
              attendanceStatus: 'SCHEDULED',
              appointment_category_id: toIntId(this.eventForm.value.appointmentCategory),
              subcategory_id: toIntId(this.eventForm.value.subcategory),
              rescheduleReason: result.reason
            }
          };
          
          const response = await firstValueFrom(
            this.taskService.rescheduleAppointment(reschedulePayload)
          );
          
          this.isLoading = false;
          
          this.dialogRef.close({
            action: 'rescheduled',
            newAppointment: response.data
          });

          this.modalDataService.emitEvent('create', response.data);
          
        } catch (error) {
          console.error('Error rescheduling appointment:', error);
          this.isLoading = false;

          const serverMessage =
            error?.error?.message ||
            error?.message ||
            'Failed to reschedule appointment. Please try again.';

          this.dialog.open(AttendanceStatusModalComponent, {
            width: '400px',
            data: {
              title: 'Reschedule Failed',
              message: Array.isArray(serverMessage)
                ? serverMessage.join(' ')
                : serverMessage,
            }
          });
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

  }

 

  /**
   * Handle calendar selection and auto-hide on mobile
   */
  onCalendarDataSelected(event: any): void {
    this.calendarData(event);

    // this.hideCalendar();
    }

  

    showAttendanceStatusModal(editMode: boolean): void {
      const dialogRef = this.dialog.open(AttendanceStatusModalComponent, {
        width: '500px',
        disableClose: true,
        data: {
          editMode: editMode,
          activity: this.activity
        }
      });
    
      dialogRef.afterClosed().subscribe(result => {
        
        if (result) {
          if (result.status === 'SHOW') {
            this.updateAttendanceStatus('SHOW', true);
            if (result.outcome_id) {
              this.selectedOutcome = result.outcome_id;
            }
            this.saveEvent(true);
          } else if (result.status === 'NO_SHOW') {
            this.updateAttendanceStatus('NO_SHOW', true);
            this.saveEvent(true);
          } else if (result.status === 'RESCHEDULED') {
            this.rescheduleAppointment();
          } else if (result.status === 'CANCEL') {
            this.updateAttendanceStatus('CANCEL', true);
            this.saveEvent(true);
          }
        }
      });
    }

    onAttendanceChipSelect(event: any, status: string): void {
      if (!event.selected) return;
      if (status === this.currentAttendanceStatus) return;
    
      if (status === 'SHOW' || status === 'RESCHEDULED') {
        this._pendingChipStatus = status;
        this.openAttendanceStatusModal();
      } else {
        // NO_SHOW, CANCEL, SCHEDULED → simple confirmation
        this._pendingChipStatus = null;
        this.updateAttendanceStatus(status);
        // updateAttendanceStatus already handles revert on cancel via StatusConfirmationDialogComponent
      }
    }

  timeRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const start = group.get('startTime')?.value;
    const end = group.get('endTime')?.value;
    
    if (!start || !end) {
      return null;
    }

    const parseTime = (timeStr: string): number | null => {
      const trimmed = timeStr.trim();
      const match = trimmed.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!match) {
        return null;
      }
      let hour = parseInt(match[1], 10);
      const minute = parseInt(match[2], 10);
      const period = match[3].toUpperCase();

      if (period === 'PM' && hour < 12) {
        hour += 12;
      } else if (period === 'AM' && hour === 12) {
        hour = 0;
      }
      return hour * 60 + minute;
    };

    const startTotal = parseTime(start);
    const endTotal = parseTime(end);

    if (startTotal === null || endTotal === null) {
      return null;
    }

    return startTotal >= endTotal ? { timeRangeInvalid: true } : null;
  };

  validateDateRange: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const startDateValue = group.get('startDate')?.value;
    const dueDateValue = group.get('dueDate')?.value;
    const typeValue = group.get('type')?.value;
    
    const selectedActivity = this.activityTypes.find(row => row.id === typeValue);
    
    if (startDateValue && dueDateValue && selectedActivity?.isTask) {
      const startDate = new Date(startDateValue);
      const dueDate = new Date(dueDateValue);
      
      const normalizedStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()).getTime();
      const normalizedDueDate = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate()).getTime();
    
      if (normalizedStartDate > normalizedDueDate) {
        return { dateRangeInvalid: 'Start Date cannot be after Due Date' };
      }
    }
    return null;
  };

  onTimeChange(field: string, value: string): void {
    // Handle time changes if needed
  }

  async getLeads(search?: string) {
    // Form value is the most reliable source — it's set during buildFormData
    // and isn't affected by dataInfo mutations from emitLeadUpdate
    const formLeadValue = this.eventForm?.get('lead')?.value;
    const formLeadId =
      formLeadValue?.id ??
      (typeof formLeadValue === 'string' || typeof formLeadValue === 'number'
        ? formLeadValue
        : null);
  
    const preselectedId =
      formLeadId?.toString() ||
      this.dataInfo?.lead?.id?.toString() ||
      this.dataInfo?.defaultLead?.toString() ||
      undefined;
  
    const response = await firstValueFrom(
      this.leadsService.get(
        {
          pageIndex: 1,
          pageSize: 5,
          searchValue: search ?? '',
          preselectedId,
        },
        'leadSearch',
      ),
    );
  
    this.leadOptions = response.data.map((item: any) => ({
      name:
        item.fullName ||
        item.email ||
        (item?.prefix || '') + (item?.phoneNumber || '') ||
        'No name',
      id: item.id,
    }));
    this.leads = response.data;
  
    if (preselectedId && !this.eventForm.value.campus) {
      const matched = this.leads.find(
        (row) => row.id?.toString() === preselectedId,
      );
      if (matched?.campus?.id) {
        this.eventForm.patchValue({ campus: matched.campus.id.toString() });
      }
    }
  }

  async getContacts(search?: string) {
    const response = await firstValueFrom(
      this.leadsService.get(
        {
          pageIndex: 1,
          pageSize: 5,
          searchValue: search ? search : '',
        },
        'contacts',
      ),
    );
    this.attendeeOptions = response.data.map((item: any) => ({
      name: `${item.name} ${item.lastName}(${item.email})`,
      id: item.id,
      email: item.email
    }));
    this.contacts = response.data;
  }

  handleValueChanged(value){
    this.getLeads(value)
  }

  handleContactValueChanged(value){
    this.getContacts(value)
  }

  isNumericString(str) {
    return /^[0-9]+$/.test(str);
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  /** Resolve the form's currently selected lead to a numeric id, or null. */
  private resolveFormLeadId(): number | null {
    const v = this.eventForm?.value?.lead;
    if (v === null || v === undefined || v === '') return null;
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      if (this.isNumericString(v)) return parseInt(v, 10);
      if (v.trim() === '') return null;
      const found = this.leads?.find(row => row.fullName === v);
      return found?.id ?? null;
    }
    if (typeof v === 'object' && v?.id != null) {
      return typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
    }
    return null;
  }

  /** True iff the form's currently selected type is an appointment type. */
  private isFormTypeAppointment(): boolean {
    const typeId = this.eventForm?.value?.type;
    if (!typeId) return false;
    return !!this.activityTypes.find(t => t.id == typeId)?.is_appointment;
  }

  /**
   * Block completion flows when the activity is being saved as an appointment
   * but no lead is attached. Mirrors the backend rule (tasks.service.ts) and
   * prevents outcome side-effects (enroll_lead / mark_lead_as_lost) from firing
   * pre-save against a stale lead. Returns true if the action was blocked.
   */
  private blockIfAppointmentWithoutLead(): boolean {
    if (this.isRecurring) return false;
    if (!this.isFormTypeAppointment()) return false;
    if (this.resolveFormLeadId()) return false;
    this.dialog.open(DialogComponent, {
      data: {
        header: 'Lead Required',
        content: 'An appointment must be linked to a lead. Please select a lead before completing.',
        isInfo: true,
      },
      width: '400px',
    });
    return true;
  }


async saveEvent(skipAttendanceValidation: boolean = false, forceShowRecurrenceScope: boolean = false, skipRecurrenceScope: boolean = false) {
  if (this.isSaving) {
    return;
  }

  this.isSaving = true;
  
  try {
    const shouldProceed = await this.checkForActiveFollowUp();
    if (!shouldProceed) {
      this.isSaving = false;
      return;
    }

    // Block save if it's an appointment with no lead assigned.
    // Use the FORM's selected type (the user's intent at save time) rather than
    // this.activity, which can be stale after the user changes the type in-form
    // (e.g. follow-up → campus tour) without that propagating back to this.activity.
    // (Recurring activities cannot have a lead, so this gate is skipped.)
    if (this.isFormTypeAppointment() && !this.resolveFormLeadId() && !this.isRecurring) {
      this.dialog.open(DialogComponent, {
        data: {
          header: 'Lead Required',
          content: 'An appointment must be linked to a lead. Please select a lead before saving.',
          isInfo:true
        },
        width: '400px',
      });
      this.isSaving = false;
      return;
    }

    const campusControl = this.eventForm.get('campus');
    if (campusControl) {
      campusControl.clearValidators();
      campusControl.updateValueAndValidity();
    }
    
      if (!this.allDay && this.activityTypes.find(row => row.id === this.eventForm.value.type)?.isTask) {
        this.allDay = true;
        this.eventForm.patchValue({
          startTime: null,
          endTime: null
        });
      }
      
      const selectedType = this.activityTypes.find(type => type.id === this.eventForm.value.type);
      if (selectedType?.is_appointment) {
        // Only show modal if:
        // 1. Not skipping validation
        // 2. Appointment is in the past
        // 3. Status is SCHEDULED
        // 4. We're trying to COMPLETE (not uncomplete)
        const isCompleting = this.eventForm.value.completed;
        
        if (!skipAttendanceValidation && this.isAppointmentInPast() && this.currentAttendanceStatus === 'SCHEDULED' && isCompleting) {
          this.showAttendanceStatusModal(this.editMode);
          this.isSaving = false;
          return;
        }
  
        if (this.showOutcomeSelection && this.isOutcomeRequired() && !this.selectedOutcome) {
          this.showOutcomeRequiredDialog();
          this.isSaving = false;
          return;
        }
        
        // Auto-set to SHOW if completing and still SCHEDULED (only when not skipping validation)
        if (this.eventForm.value.completed && this.currentAttendanceStatus === 'SCHEDULED' && !skipAttendanceValidation) {
          this.currentAttendanceStatus = 'SHOW';
        }
      }
      
      if (this.eventForm.valid) {
        // Show loading state
        this.isLoading = true;
        
        let endDate;
        if (this.allDay && this.eventForm.value.dueDate) {
          endDate = updateTime(this.eventForm.value.dueDate, this.eventForm.value.endTime);
        } else {
          endDate = updateTime(this.eventForm.value.startDate, this.eventForm.value.endTime);
        }
    
        const leadValue = this.eventForm.value.lead;
        let leadId: number | null = null;
        
        if (leadValue) {
          if (typeof leadValue === 'number') {
            leadId = leadValue;
          } else if (typeof leadValue === 'string') {
            if (this.isNumericString(leadValue)) {
              leadId = parseInt(leadValue, 10);
            } else if (leadValue.trim() !== '') {
              const foundLead = this.leads.find(row => row.fullName === leadValue);
              leadId = foundLead?.id || null;
            }
          } else if (leadValue?.id) {
            leadId = typeof leadValue.id === 'string' ? parseInt(leadValue.id, 10) : leadValue.id;
          }
        }
    
        let attendeesData = [];
        if (this.showDefaultAttendees && this.eventForm.value.meetingLink) {
          if (this.eventForm.value?.assignedTo) {
            const assignedUser = this.users.find(user => user.id.toString() === this.eventForm.value.assignedTo);
            attendeesData.push({ 
              id: parseInt(this.eventForm.value.assignedTo),
              email: assignedUser?.email
            });
          }
          if (leadId) {
            const leadUser = this.leads.find(row => row.id == leadId)?.studentUser;
            attendeesData.push({ 
              id: parseInt(leadUser?.id),
              email: leadUser.email
            });
          }
        } else {
          attendeesData = this.eventForm.value.attendees?.map(attendee => {
            if (typeof attendee.id === 'string' && attendee.id.startsWith('new-')) {
              return {
                id: attendee.id,
                email: attendee.name
              };
            } else {
              const emailMatch = attendee.name.match(/\(([^)]+)\)/);
              let email = emailMatch ? emailMatch[1] : null;
  
              if (!email && this.isValidEmail(attendee.name)) {
                email = attendee.name;
              }
              
              return { 
                id: attendee.id,
                email: email
              };
            }
          }) || [];
        }
    
        const formData: any = {
          ...this.eventForm.value,
          lead: leadId,
          title: this.eventForm.value.name || this.activity?.name,
          allDay: this.allDay,
          startDate: updateTime(this.eventForm.value.startDate, this.eventForm.value.startTime, true),
          endDate: endDate,
          attendees: attendeesData,
          dueDate: endDate,
          appointment_category_id: this.eventForm.value.appointmentCategory || null,
          subcategory_id: this.eventForm.value.subcategory || null,
          attendanceStatus: this.currentAttendanceStatus,
          outcome_id: this.selectedOutcome,
          isVirtual: this.isVirtual,
          recurrence: this.eventForm.value.recurrence || undefined,
        };
        delete formData.name;
        delete formData.startTime;
        delete formData.endTime;

        // Recurring activities cannot have a lead — strip it from the payload.
        if (this.isRecurring) {
          formData.lead = null;
        }

        // Handle recurring event edit - show scope dialog
        if (this.editMode && this.dataInfo?.recurrence_rule_id && !skipRecurrenceScope) {
          const currentSnapshot = this.serializeFormForComparison(this.eventForm.value);
          const hasChanges =
            this.initialFormSnapshot !== null &&
            currentSnapshot !== this.initialFormSnapshot;
          // No changes and not a mark-as-done flow: do nothing, close silently
          if (!forceShowRecurrenceScope && !hasChanges) {
            this.isSaving = false;
            this.isLoading = false;
            if (this.isModal && this.dialogRef) {
              this.dialogRef.close();
            } else {
              this.activityClosed.emit();
            }
            return;
          }
          const { RecurrenceScopeDialogComponent } = await import('../recurrence-scope-dialog/recurrence-scope-dialog.component');
          const scopeRef = this.dialog.open(RecurrenceScopeDialogComponent, {
            width: '400px',
            data: { action: 'edit' },
          });
          const scope = await firstValueFrom(scopeRef.afterClosed());
          if (!scope) {
            this.isSaving = false;
            this.isLoading = false;
            return;
          }
          formData.recurrenceScope = scope;
        }

        const response = await (this.editMode
          ? firstValueFrom(this.taskService.put(formData, this.dataInfo.id))
          : firstValueFrom(this.taskService.post(formData)));
          
        const isBulkScope = formData.recurrenceScope === 'THIS_AND_FOLLOWING' || formData.recurrenceScope === 'ALL_EVENTS';
        // On create: if the new task has a recurrence config, the backend created
        // multiple sibling rows but only returned the template — emit bulk-update
        // so all list subscribers refetch and show every instance.
        const createdRecurringSeries = !this.editMode && !!formData.recurrence;
        const action: ActivityAction = this.editMode
          ? (isBulkScope ? 'bulk-update' : 'update')
          : (createdRecurringSeries ? 'bulk-update' : 'create');
        this.modalDataService.emitEvent(action, response.data);
        
        if (this.isEmbedded) {
          this.isLoading = false;
          this.isSaving = false;
          return response;
        }
        
        if (!this.isModal) {
          this.taskService.setResult({editMode: this.editMode, data: response.data});
        } else if (this.dataInfo.listView || this.dataInfo.task) {
          this.dialogRef.close(response.data); 
        } else if (this.editMode || this.dataInfo.isExternal) {
          this.taskService.setResult({editMode: this.editMode, data: response.data});
          this.dialogRef.close();
        } else {
          this.dialogRef.close(response.data); 
        }
        
        this.isLoading = false;
        this.isSaving = false;
        return response;
      } else {
        this.isSaving = false;
      }
    } catch (error) {
      console.error('Error saving event:', error);
      this.isLoading = false;
      this.isSaving = false;
      
      this.dialog.open(DialogComponent, {
        data: {
          header: 'Save Failed',
          content: 'Failed to save the activity. Please try again.',
        },
        width: '400px',
      });
    }
  }
  private async checkForActiveFollowUp(): Promise<boolean> {
    // Skip check when editing - only validate on create
    if (this.editMode) {
      return true;
    }

    let leadId = this.eventForm.value.lead;
    const typeId = this.eventForm.value.type;
    const activityType = this.activityTypes.find(type => type.id === typeId);

    // Handle leadId being an object (e.g., {id: 61, name: 'test'})
    if (leadId && typeof leadId === 'object') {
      leadId = leadId.id;
    }

    // Convert string to number if needed
    if (leadId && typeof leadId === 'string') {
      leadId = parseInt(leadId, 10);
    }

    if (!this.companyActiveFollowUpCheck) {
      return true;
    }

    if (!activityType?.is_follow_up) {
      return true;
    }

    if (!leadId) {
      return true;
    }

    try {
      const excludeTaskId = this.editMode ? this.dataInfo?.id : undefined;
      const result = await firstValueFrom(
        this.taskService.checkActiveFollowUp(leadId, excludeTaskId)
      );

      if (result.hasActiveFollowUp) {
        const dialogRef = this.dialog.open(DialogComponent, {
          data: {
            header: 'Active Follow-Up Exists',
            content: 'There is already an active follow-up for this lead. Are you sure you want to create another one?',
            type: 'warning',
            buttonName: 'Create Anyway'
          },
          width: '400px',
        });

        const confirmed = await firstValueFrom(dialogRef.afterClosed());
        return !!confirmed;
      }

      return true;
    } catch (error) {
      console.error('Error checking active follow-up:', error);
      return true;
    }
  }

  async onMarkAsDoneChange(event: any) {
    event.source.checked = this.dataInfo.completed;
    await this.markAsDone();
  }

  /**
   * Handle attendance chip selection change - revert and open modal
   */
  async onAttendanceChipChange(event: any) {
    // Revert the chip selection to current status
    if (this.statusChips) {
      this.statusChips.value = this.currentAttendanceStatus;
    }
    // Open the modal
    await this.openAttendanceStatusModal();
  }

  /**
   * Open the Mark Done modal when clicking on Attendance Status
   */
  async openAttendanceStatusModal() {
    // Block when the activity is an appointment but the form has no lead — opening the
    // modal would let outcome side-effects fire pre-save against a stale lead.
    if (this.blockIfAppointmentWithoutLead()) {
      return;
    }

    const { MarkDoneModalComponent } = await import('../app-mark-done-modal/app-mark-done-modal.component');

    // Ensure we have a proper lead reference for outcome actions.
    // Source from the FORM's current lead (the user's intent), not dataInfo.lead which
    // can be stale after the user removed the lead in the form.
    const formLeadId = this.resolveFormLeadId();
    let leadRef: any = null;
    if (formLeadId) {
      leadRef = this.leads?.find(l => l.id === formLeadId) || {
        id: formLeadId,
        fa_advisor_id: this.dataInfo?.lead?.fa_advisor_id ?? this.dataInfo?.fa_advisor_id ?? null,
      };
    }

    const currentActivity = {
      ...this.dataInfo,
      lead: leadRef,
      type: this.activityTypes.find(type => type.id === this.eventForm.value.type),
      attendanceStatus: this.currentAttendanceStatus
    };

    const dialogRef = this.dialog.open(MarkDoneModalComponent, {
      width: '500px',
      disableClose: false,
      data: { activity: currentActivity, initialStatus: this._pendingChipStatus }
    });
    

    const result = await firstValueFrom(dialogRef.afterClosed());

    if (result) {
      if (result.status === 'RESCHEDULED') {
        if (result.rescheduleData) {
          // Reschedule data available from modal - call the API to actually reschedule
          try {
            const rescheduleResult = await this.activityCompletionService.handleReschedule(
              currentActivity, result.rescheduleData, this.eventForm
            );
            this.dialogRef.close({
              action: 'rescheduled',
              newAppointment: rescheduleResult?.newAppointment
            });
          } catch (error) {
            console.error('Error rescheduling appointment:', error);
          }
        } else {
          // Fallback: reschedule dialog didn't open inside modal, open it directly
          this.rescheduleAppointment();
        }
        return;
      }

      // Update attendance status
      if (result.status) {
        this.currentAttendanceStatus = result.status;
        if (this.statusChips) {
          this.statusChips.value = result.status;
        }
      }

      // Update outcome if provided
      if (result.outcome_id) {
        this.selectedOutcome = result.outcome_id;
      }

      // Update form and data
      this.eventForm.patchValue({
        completed: result.completed,
        status: result.completed ? 'done' : 'todo'
      });

      this.dataInfo = {
        ...this.dataInfo,
        completed: result.completed,
        status: result.completed ? 'done' : 'todo',
        attendanceStatus: this.currentAttendanceStatus
      };

      // Save activity directly in edit mode (same as Mark as Done)
      if (this.editMode) {
        await this.saveEvent(true);
      }

      // Get lead reference for outcome actions.
      // Prefer the modal's result lead (set from form-derived leadRef above), then
      // fall back to the form's current lead. Do NOT fall back to dataInfo.lead —
      // it can be stale (the originally-loaded lead) after the user removed it.
      let leadId: number | null = null;
      const resultLead = result.lead;
      if (resultLead) {
        if (typeof resultLead === 'object') {
          leadId = resultLead.id ?? null;
        } else if (typeof resultLead === 'number') {
          leadId = resultLead;
        } else if (typeof resultLead === 'string' && this.isNumericString(resultLead)) {
          leadId = parseInt(resultLead, 10);
        }
      }
      if (!leadId) {
        leadId = this.resolveFormLeadId();
      }
      const leadObj = (resultLead && typeof resultLead === 'object') ? resultLead : (leadId ? { id: leadId } : null);
      console.log('🔍 leadObj:', leadObj);

      // Handle mark_lead_as_lost outcome - call the close API
      console.log('🔍 mark_lead_as_lost:', result.mark_lead_as_lost, 'lost_reason_id:', result.lost_reason_id, 'leadId:', leadId);
      if (result.mark_lead_as_lost && result.lost_reason_id && leadId) {
        console.log('✅ Calling markLeadAsLost');
        this.activityCompletionService.markLeadAsLost(Number(leadId), result.lost_reason_id);
      }

      // Handle ask_for_new_activity outcome - open create activity modal
      console.log('🔍 ask_for_new_activity:', result.ask_for_new_activity, 'leadObj:', leadObj);
      if (result.ask_for_new_activity && leadObj) {
        console.log('✅ Calling openCreateActivityForLead');
        setTimeout(() => {
          this.activityCompletionService.openCreateActivityForLead(leadObj);
        }, 300);
      }

      // Handle enroll_lead outcome - enroll the lead
      console.log('🔍 enroll_lead:', result.enroll_lead, 'enrollmentData:', result.enrollmentData);
      if (result.enroll_lead && leadId && result.enrollmentData) {
        console.log('✅ Calling enrollLead');
        this.activityCompletionService.enrollLead(Number(leadId), result.enrollmentData.start_at, result.enrollmentData.note);
      }
    } else {
      // User cancelled — revert chip back to the actual current status
      this._pendingChipStatus = null;
      if (this.statusChips) {
        this.statusChips.value = this.currentAttendanceStatus;
      }
    }
  }

  navigateToDetail(option: { name: string; id: string }): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.router.navigate(['/leads/leads-managment/manage', option.id]);
  }

  async markAsDone() {
    const isCurrentlyCompleted = this.dataInfo.completed;

    // If currently completed, just toggle off without showing modal
    if (isCurrentlyCompleted) {

      // Capture originals so we can restore exactly on revert.
      const originalCompleted = this.eventForm.value.completed;
      const originalStatus = this.eventForm.value.status;
      const originalDataInfoCompleted = this.dataInfo.completed;
      const originalDataInfoStatus = this.dataInfo.status;
      const originalAttendanceStatus = this.currentAttendanceStatus;
      const originalSelectedOutcome = this.selectedOutcome;
      const originalShowOutcomeSelection = this.showOutcomeSelection;

      // Reset to not completed
      this.currentAttendanceStatus = 'SCHEDULED';
      this.selectedOutcome = null;
      this.showOutcomeSelection = false;

      this.eventForm.patchValue({
        completed: false,
        status: 'todo'
      });

      this.dataInfo = {
        ...this.dataInfo,
        completed: false,
        status: 'todo',
        attendanceStatus: 'SCHEDULED'
      };

      if (this.editMode) {
        // Uncompleting: no scope dialog — it's just completed=false.
        const saved = await this.saveEvent(true, false, true);
        if (!saved) {
          this.eventForm.patchValue({
            completed: originalCompleted,
            status: originalStatus,
          });
          this.dataInfo = {
            ...this.dataInfo,
            completed: originalDataInfoCompleted,
            status: originalDataInfoStatus,
          };
          this.currentAttendanceStatus = originalAttendanceStatus;
          this.selectedOutcome = originalSelectedOutcome;
          this.showOutcomeSelection = originalShowOutcomeSelection;
        }
      }
      return;
    }

    // If not completed, go through the normal modal flow.
    // Block when the activity is an appointment but the form has no lead — opening the
    // modal would let outcome side-effects (enroll_lead / mark_lead_as_lost) fire pre-save
    // against the stale dataInfo.lead even though the save itself would be rejected.
    if (this.blockIfAppointmentWithoutLead()) {
      return;
    }

    // Ensure we have a proper lead reference for outcome actions.
    // Source from the FORM's current lead (the user's intent at this moment), not
    // dataInfo.lead which can be stale after the user removed the lead in the form.
    const formLeadId = this.resolveFormLeadId();
    let leadRef: any = null;
    if (formLeadId) {
      leadRef = this.leads?.find(l => l.id === formLeadId) || {
        id: formLeadId,
        fa_advisor_id: this.dataInfo?.lead?.fa_advisor_id ?? this.dataInfo?.fa_advisor_id ?? null,
      };
    }
    const currentActivity = {
      ...this.dataInfo,
      lead: leadRef,
      type: this.activityTypes.find(type => type.id === this.eventForm.value.type),
      attendanceStatus: this.currentAttendanceStatus
    };

    // Capture originals BEFORE the service call — the service may patch the
    // form (e.g. appointment attendance modal writes completed/status).
    const originalCompleted = this.eventForm.value.completed;
    const originalStatus = this.eventForm.value.status;
    const originalDataInfoCompleted = this.dataInfo.completed;
    const originalDataInfoStatus = this.dataInfo.status;
    const originalAttendanceStatus = this.currentAttendanceStatus;

    const result = await this.activityCompletionService.markActivityAsDone(
      currentActivity,
      this.eventForm
    );

    if (result) {
      // Handle rescheduled: close dialog since a new appointment was created
      if (result.action === 'rescheduled') {
        this.dialogRef.close({
          action: 'rescheduled',
          newAppointment: result.newAppointment
        });
        return;
      }

      // Apply status from modal result
      if (result.status) {
        this.currentAttendanceStatus = result.status;
      }

      this.eventForm.patchValue({
        completed: true,
        status: 'done'
      });

      this.dataInfo = {
        ...this.dataInfo,
        completed: true,
        status: 'done',
        attendanceStatus: this.currentAttendanceStatus
      };

      if (result.outcome_id) {
        this.selectedOutcome = result.outcome_id;
      }

      if (this.editMode) {
        const saved = await this.saveEvent(true, !!this.dataInfo?.recurrence_rule_id);
        if (!saved) {
          this.eventForm.patchValue({
            completed: originalCompleted,
            status: originalStatus,
          });
          this.dataInfo = {
            ...this.dataInfo,
            completed: originalDataInfoCompleted,
            status: originalDataInfoStatus,
          };
          this.currentAttendanceStatus = originalAttendanceStatus;
          return;
        }
      }
    }
  }

  closeModal(result?: any) {
   if (this.isModal) {
      this.dialogRef.close(result);
    } else {
      this.activityClosed.emit(result);
    }
  }

  details(){
    this.dialogRef.close("details"); 
  }

  getSelectedSubcategoryName(): string {
    const selectedId = this.eventForm.get('subcategory')?.value;
    if (!selectedId) return '';
    
    const selectedSubcategory = this.subcategories.find(sub => sub.id == selectedId);
    return selectedSubcategory ? selectedSubcategory.name : '';
  }

  onSubcategoryChange(event: any): void {
    if (event.value) {
      this.showSubcategoryDropdown = false;
    }
  }

  async loadActivityOutcomes() {
    if (!this.activity?.id) return;
    
    try {
      const response : any = await firstValueFrom(
        this.companyService.getActivityTypeOutcomes(this.activity.id)
      );
      this.activityOutcomes = response || [];
      this.showOutcomeSelection = response.length ? true : false;
      
      // If we have an existing outcome_id and outcomes are loaded, set the selected outcome
      const dataSource = this.getInitializationData();
      if (dataSource?.appointment && dataSource.appointment?.outcome_id && this.activityOutcomes.length > 0) {
        this.selectedOutcome = dataSource.appointment?.outcome_id;
      }
    } catch (error) {
      console.error('Error loading activity outcomes:', error);
      this.activityOutcomes = [];
    }
  }

  async removeSuggestion(event: Event, suggestion: any) {
    event.stopPropagation(); // Prevent triggering insertSuggestion
    
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header: 'Remove Suggestion',
        content: 'Are you sure you want to remove this suggestion?',
      },
      width: '300px',
    });
  
    const confirmed = await dialogRef.afterClosed().toPromise();
    
    if (!confirmed) return;
    
    try {
      await firstValueFrom(this.noteService.delete(suggestion.id, 'usage'));
      this.userNoteUsage = this.userNoteUsage.filter(s => s.id !== suggestion.id);
    } catch (error) {
      console.error('Failed to remove suggestion:', error);
    }
  }

  goToActivitiesSettings(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.router.navigate(['/settings/profile/company'], { queryParams: { tab: 'activities' } });
  }

  /**
   * Show dialog when outcome is required but not selected
   */
  private showOutcomeRequiredDialog(): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header: 'Outcome Required',
        content: 'Please select an outcome before saving this appointment.',
      },
      width: '400px',
    });

    // Optional: Handle dialog result if needed
    dialogRef.afterClosed().subscribe(result => {
      // Dialog closed, user can now select outcome
    });
  }
}